import script from "./workflowOppEditor.vue?vue&type=script&lang=js"
export * from "./workflowOppEditor.vue?vue&type=script&lang=js"

import "./workflowOppEditor.vue?vue&type=style&index=0&id=a41503d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a41503d8"]])

export default __exports__